module.exports = __webpack_public_path__ + "static/Reach-bcda012a3eda9437f60c97f0b3e57a79.png";